<!--~
  ~ Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf='command.hasCustomUi(); then customUi; else standard'></ng-container>
<ng-template #standard>
    <ng-container *ngIf='shouldDisplay$ | async'>
        <button
            mat-icon-button
            *ngIf='!isInBottomSheet'
            (click)='invoke()'
            [disabled]='shouldDisable$ | async'
            [csActiveTool]='commandName'
            [deactivate$]='deactivate$'
            (deactivated)='toolDeactivated()'
            [matMenuTriggerFor]='(hasMenu$ | async) ? widgetMenu : null'
            matTooltip="{{ label }}{{ hotKey ? ' (' + hotKey + ')' : '' }}"
            [attr.aria-label]='label'>
            <mat-icon [svgIcon]='icon'></mat-icon>
        </button>

        <button
            mat-icon-button
            *ngIf='isInBottomSheet'
            (click)='invoke()'
            [disabled]='shouldDisable$ | async'
            [csActiveTool]='commandName'
            [deactivate$]='deactivate$'
            (deactivated)='toolDeactivated()'
            [matMenuTriggerFor]='(hasMenu$ | async) ? widgetMenu : null'
            [matTooltip]='label'
            [attr.aria-label]='label'>
            <mat-icon [svgIcon]='icon'></mat-icon>
        </button>
    </ng-container>
</ng-template>

<ng-template #customUi csWidgetCustomUi></ng-template>

<mat-menu #widgetMenu (closed)='menuClosed($event)'>
    <ng-template matMenuContent>
        <ng-container *ngFor='let menuItem of widgetMenuItems$ | async'>
            <button mat-menu-item (click)='menuItem.action()'>
                <mat-icon *ngIf='menuItem.icon' [svgIcon]='menuItem.icon'></mat-icon>
                <span>{{ menuItem.label }}</span>
            </button>
        </ng-container>
    </ng-template>
</mat-menu>